import { ExternalLink, MapPin } from "lucide-react";
import { Reveal } from "@/components/MaskedLines";

const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Meranggi+Garment+Jl.+Raya+Udayana+Blahbatuh+Gianyar+Bali+80581";
const MAPS_EMBED =
  "https://maps.google.com/maps?q=Meranggi%20Garment%20Jl.%20Raya%20Udayana%20Blahbatuh%20Gianyar%20Bali%2080581&z=14&output=embed";

export const LocationSection = () => (
  <section id="location" data-testid="location-section" className="bg-[#f5f5f7] py-24 sm:py-32">
    <div className="mx-auto max-w-6xl px-5 sm:px-6">
      <Reveal className="mx-auto max-w-3xl text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#86868b]">Factory Location</p>
        <h2
          data-testid="location-heading"
          className="mt-4 text-3xl font-semibold leading-[1.12] tracking-tight text-[#1d1d1f] sm:text-4xl lg:text-5xl"
        >
          Visit our factory in Gianyar, Bali.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 lg:grid-cols-[1fr_1.3fr]">
        <Reveal>
          <div data-testid="location-address-card" className="flex h-full flex-col rounded-[28px] bg-white p-8 sm:p-10">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#f5f5f7]">
              <MapPin size={20} strokeWidth={1.75} className="text-[#1d1d1f]" />
            </span>
            <h3 className="mt-6 text-2xl font-semibold tracking-tight text-[#1d1d1f]">Meranggi Garment</h3>
            <address className="mt-3 text-base not-italic leading-relaxed text-[#1d1d1f]/80">
              Jl. Raya Udayana
              <br />
              Kecamatan Blahbatuh
              <br />
              Kabupaten Gianyar, Bali 80581
              <br />
              Indonesia
            </address>
            <p className="mt-4 text-sm text-[#86868b]">Operated by CV Meranggi Jaya.</p>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="location-map-button"
              className="group mt-auto inline-flex w-fit items-center gap-2 rounded-full bg-[#0066cc] px-6 py-2.5 pt-2.5 text-sm font-medium text-white transition-colors duration-200 hover:bg-[#0077ed] max-lg:mt-8"
            >
              Get Directions
              <ExternalLink size={14} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div
            data-testid="location-embed-map"
            className="h-full min-h-[360px] overflow-hidden rounded-[28px] bg-white shadow-[0_24px_80px_-32px_rgba(0,0,0,0.15)]"
          >
            <iframe
              title="Meranggi Garment factory location map"
              src={MAPS_EMBED}
              className="h-full min-h-[360px] w-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
